export default "__VITE_ASSET__de719f77__"